module.exports = new __parcel__URL__("alchemist_lab_level_1.3187608e.png").toString();